{
    "name": "Voxelab",
    "version": "01.10.00.01",
    "force_update": "0",
    "description": "Voxelab configurations",
    "machine_model_list": [
        {
            "name": "Voxelab Aquila X2",
            "sub_path": "machine/Voxelab Aquila X2.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "0.16mm Optimal @Voxelab AquilaX2",
            "sub_path": "process/0.16mm Optimal @Voxelab AquilaX2.json"
        },
        {
            "name": "0.20mm Standard @Voxelab AquilaX2",
            "sub_path": "process/0.20mm Standard @Voxelab AquilaX2.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "Generic ABS @Voxelab",
            "sub_path": "filament/Generic ABS @Voxelab.json"
        },
        {
            "name": "Generic PETG @Voxelab",
            "sub_path": "filament/Generic PETG @Voxelab.json"
        },
        {
            "name": "Generic PLA @Voxelab",
            "sub_path": "filament/Generic PLA @Voxelab.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "Voxelab Aquila X2 0.4 nozzle",
            "sub_path": "machine/Voxelab Aquila X2 0.4 nozzle.json"
        }
    ]
}
